export const logout = () => {
  localStorage.removeItem("AuthToken");
  localStorage.removeItem("RefreshToken");
};

/** Code to convert Array of objects to dot notation */
export const jsonToDotNotation = (arr) => {
  const htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "'",
    "'": "&apos;",
  };

  const data: any = [];
  for (let i = 0; i < arr.length; i++) {
    const res = {};
    (function recurse(obj, current) {
      for (const key in obj) {
        const value = obj[key];
        const newKey: any = current
          ? current + "." + key
          : capitalizeFirstLetter(key);
        if (value && typeof value === "object") {
          recurse(value, newKey);
        } else {
          res[newKey] =
            value === null
              ? ""
              : key === "questionText"
              ? value.replace(/([\\"])/g, (match) => htmlEntities[match])
              : value;
        }
      }
    })(arr[i]);

    data.push(res);
  }

  return data;
};
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

/** @params arr = original array refArr = Array to validate */
export const containsAll = (arr: Array<any>, refArr: Array<any>) => {
  return refArr.length && refArr.every((val) => arr.includes(val));
};

export const arrayToQueryParams = (arr, key) => {
  let str = "";
  arr.map((ds) => {
    str += `${key}=${ds}&&`;
  });
  str = str.substring(0, str.lastIndexOf("&&"));
  return str;
};

export const getJoinedStringByArray = (arr: Array<any> | undefined): string => {
  return (arr || []).join(",");
};

export const getJoinedStringByItem = (item: any): string => {
  return !item ? "" : item.toString();
};

export const downloadFile = (data: any, fileName: string) => {
  const fileURL = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = fileName;
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
};
